// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xU4Y","right":"Footer_right__24SnC","buttons":"Footer_buttons__2seaz"};